
export default function NotFound(){
    return (
        <div class="main-div">
        <div class="main-content">

            <div class="no-data">
                <img src={process.env.PUBLIC_URL + "assets/no-data.svg"}/>
            </div>
            <div>Nothing here</div>
        </div>
        </div>
    )
}